import axios from 'axios';

export var LoaderMixin = {
  methods: {
    loadPostcards() {
      this.$store.commit('incrementCountLoading');
      axios
        .get(
          process.env.VUE_APP_BASE_URL + '/wp-json/geschenkbox/v1/get_postcards'
        )
        .then((response) => {
          let postcards = [];

          response.data.forEach((item) => {
            if (
              // item.stock_quantity === null ||
              // item.stock_quantity >=
              //   parseInt(this.$store.getters.getSelectedQty) ||
              // (item.allow_backorders === 'ja' && this.$store.getters.isB2b)
              item.stock_quantity === null ||
              item.allow_backorders === 'ja' ||
              item.stock_quantity >=
                parseInt(this.$store.getters.getSelectedQty)
            ) {
              if (item.specific_customer === '') {
                postcards.push(item);
              } else if (item.specific_customer.toString() === this.$store.getters.getUserGroupId.toString()) {
                postcards.push(item);
              }
            }
          });

          if (postcards.length > 0) {
            postcards.filter(i => {
              i.main_image_medium[0] = i.main_image_medium[0].replace(process.env.VUE_APP_BASE_URL, process.env.VUE_APP_CDN_URL);
            });
          }

          if (postcards.filter(p => p.specific_customer !== '').length > 0) {
            postcards = postcards.filter(p => p.specific_customer);
          }

          this.$store.commit('setPostcards', postcards);
          this.$store.commit('setPostcardsLoaded', true);

          if (
            localStorage.getItem('lastSelectedPostcard') !== null
          ) {
            const lastSelectedPostcard = JSON.parse(
              localStorage.getItem('lastSelectedPostcard')
            );
            if (lastSelectedPostcard.contact === 'op1') {
              this.setPostcardState(lastSelectedPostcard);
            } else {
              postcards.forEach((item) => {
                if (
                  item.id === lastSelectedPostcard.id && (
                    item.stock_quantity === null ||
                      item.stock_quantity >=
                        parseInt(this.$store.getters.getSelectedQty))
                ) {
                  this.setPostcardState(lastSelectedPostcard);
                }
              });
            }
          }
          this.$store.commit('decrementCountLoading');
        });
    },
    loadSettings () {
      this.$store.commit('setGlobalLoading', true);
      axios
        .get(
          process.env.VUE_APP_BASE_URL + '/wp-json/geschenkbox/v1/get_configurator_settings'
        )
        .then((response) => {
          this.$store.commit('setDelTimeSettings', response.data.custom_add_del_time);
          this.$store.commit('setLevel1Tags', response.data.level1_tags);
          this.$store.commit('setShipping', response.data.shipping);
          this.$root.$emit('settingsLoaded');
        });
      this.$store.commit('setGlobalLoading', false);
    },

    loadPostcardMessageTemplates () {
      const templates = {};
      axios
        .get(
          process.env.VUE_APP_BASE_URL + '/wp-json/geschenkbox/v1/get_postcard_message_templates/' + this.$store.getters.getUserGroupId
        )
        .then((response) => {
          Object.keys(response.data).forEach(key => {
            templates[key] = response.data[key];
          });

          this.$store.commit('setPostcardMessageTemplates', templates);
        });
    },

    loadLevel1() {
      this.$store.commit('incrementCountLoading');
      axios
        .get(
          process.env.VUE_APP_BASE_URL +
          '/wp-json/geschenkbox/v1/get_level_1_fast?customer_group=' +
          this.$store.getters.getUserGroupId
        )
        .then((response) => {
          var validItems = [];
          var extraItems = [];
          this.extendLvl1Req(response.data).forEach((item) => {
            if (item.extra) {
              extraItems.push(item);
            } else {
              validItems.push(item);
            }
          });
          this.$store.commit('setListItemsLevel1', validItems);
          this.$store.commit('setExtraLevel1', extraItems);
          this.$store.commit('decrementCountLoading');
          if (this.$route.params.id) {
            validItems.forEach((item) => {
              if (item.id === parseInt(this.$route.params.id)) {
                this.$store.commit('setSelectedItem', item);
                this.$root.$emit('level1Selected');
                this.$root.$emit('level1Loaded');
                this.$store.commit('setLvl1Loaded', true);
                this.$nextTick(() => {
                  this.doReplace();
                });
              }
            });
          } else if (this.$route.params.mod) {
            validItems.forEach((item) => {
              if (item.id === parseInt(this.$route.params.mod)) {
                this.$root.$emit('level1Loaded');
                this.doReplace();
                this.$store.commit('setLvl1Loaded', true);
              }
            });
          } else {
            this.$root.$emit('level1Loaded');
            this.doReplace();
            this.$store.commit('setLvl1Loaded', true);
          }
          this.init();
          this.$store.commit('decrementCountLoading');
        })
        .catch((_) => {
          this.$store.commit('decrementCountLoading');
        });
    },

    loadLevel3() {
      this.$store.commit('incrementCountLoading');
      axios
        .get(
          process.env.VUE_APP_BASE_URL +
                '/wp-json/geschenkbox/v1/get_level_3_fast'
        )
        .then((response) => {
          const helper = {};
          const lvl3 = this.extendLvl3Req(response.data);
          lvl3.forEach((product) => {
            helper[product.id] = {
              placeable: true,
            };
          });
          this.$store.commit('setLevel3Helper', helper);
          this.$store.commit('setListItemsLevel3', lvl3);
          this.doReplace();
          this.updateAfterLevel3();
          this.$store.commit('decrementCountLoading');
          this.$store.commit('setLvl3Loaded', true);
          this.$store.commit('incrementCountLoading');
          axios.get(
            process.env.VUE_APP_BASE_URL + '/wp-json/geschenkbox/v1/get_boxes'
          ).then((response) => {
            this.$store.commit('setBoxItemsLevel3', response.data);
            this.$store.commit('setLevel3Box', response.data[0]);
            this.$root.$emit('level3Loaded');
            this.updateAfterLevel3();
            this.$store.commit('decrementCountLoading');
            this.doReplace();
          });
        });
    },

    setPostcardState: function(lastSelectedPostcard) {
      this.$store.commit('setSelectedPostcardId', lastSelectedPostcard.id);
      this.$store.commit('setSelectedPostcardName', lastSelectedPostcard.name);
      this.$store.commit(
        'setSelectedPostcardImage',
        lastSelectedPostcard.image
      );
      this.$store.commit(
        'setSelectedPostcardHandwriting',
        lastSelectedPostcard.handwriting
      );
      this.$store.commit(
        'setSelectedPostcardContact',
        lastSelectedPostcard.contact
      );
      this.$store.commit('setSelectedPostcardTo', lastSelectedPostcard.to);
      this.$store.commit('setSelectedPostcardFrom', lastSelectedPostcard.from);
      this.$store.commit(
        'setSelectedPostcardMessage',
        lastSelectedPostcard.message
      );
    },

    loadFaq() {
      axios
        .get(
          `${process.env.VUE_APP_BASE_URL}/wp-json/geschenkbox/v1/get_faq`
        )
        .then((response) => {
          if (response.data.length) {
            this.$store.commit('setFaq', response.data);
            this.$root.$emit('faqLoaded');
          }
        });
    }
  }
};
